import { atom, useAtom, useAtomValue } from 'jotai'

const searchTermAtom = atom<string>('')
const filterTypeAtom = atom<'todos' | 'clientes' | 'usuarios'>('todos')

export const useSearchTerm = () => useAtom(searchTermAtom)
export const useFilterType = () => useAtom(filterTypeAtom)
export const useGetSearchTerm = () => useAtomValue(searchTermAtom)
export const useGetFilterType = () => useAtomValue(filterTypeAtom)
